import CommandHub from "../locales/en/CommandHub.json";
import CreateUser from "../locales/en/CreateUser.json";
import Navigation from "../locales/en/Navigation.json";
import ServiceTracker from "../locales/en/ServiceTracker.json";
import translation from "../locales/en/translation.json";
import {
  bankingTranslations,
  documentTranslations,
} from "@/modules/integrations";

const translations = {
  translation,
  ServiceTracker,
  Navigation,
  CommandHub,
  CreateUser,
  Banking: bankingTranslations.en,
  Documents: documentTranslations.en,
};

export default translations;
